import {
  StoreCategoryValue,
  StoreTagValue,
  STORE_CATEGORIES,
  STORE_CATEGORIES_PARENTS,
  STORE_TAGS,
} from '@bounty/constants'
import { intersection, isNil } from '@bounty/utils'

export const buildShopTags = ({
  tags: enabledTags,
}: {
  tags: StoreTagValue[]
}) => {
  return [
    {
      label: 'Shop by Tags',
      value: 'tags',
      children: intersection(STORE_TAGS, enabledTags, (x, y) => x.value === y),
    },
  ]
}

export const buildShopCategoryGroupings = ({
  categories: enabledCategories,
}: {
  categories: StoreCategoryValue[]
}) => {
  const activeCategories = intersection(
    STORE_CATEGORIES,
    enabledCategories,
    (x, y) => x.value === y,
  )

  return (
    STORE_CATEGORIES_PARENTS.map((x) => {
      const activeCategoriesForParents = activeCategories.filter(
        (y) => x.value === y.parent,
      )

      return {
        ...x,
        children: x.hasChildren ? activeCategoriesForParents : null,
      }
    })
      // Hide parents that do not have any enabled categories
      // However, some parents will never have children so we include them as well
      .filter((x) => isNil(x.children) || x.children.length > 0)
  )
}
